var _circle, _circle2, _line, _circle3, _line2, _circle4, _line3, _circle5, _line4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProgressbar3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1009,
    height: 88,
    viewBox: "0 0 1009 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 43,
    r: 37,
    fill: "#7A9647"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 254,
    cy: 43,
    r: 37,
    fill: "#7A9647"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 81.998,
    y1: 41,
    x2: 202.002,
    y2: 41,
    stroke: "#7A9647",
    strokeWidth: 5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 491.002,
    cy: 43,
    r: 37,
    fill: "#7A9647"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 319,
    y1: 41,
    x2: 439.004,
    y2: 41,
    stroke: "#7A9647",
    strokeWidth: 5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 734.002,
    cy: 44,
    r: 37,
    fill: "#7A9647"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 562,
    y1: 42,
    x2: 682.004,
    y2: 42,
    stroke: "#7A9647",
    strokeWidth: 5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 965,
    cy: 44,
    r: 40.5,
    stroke: "#A9A9A9",
    strokeWidth: 7
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 785,
    y1: 40.5,
    x2: 905.004,
    y2: 40.5,
    stroke: "#A9A9A9",
    strokeWidth: 5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressbar3);
export default __webpack_public_path__ + "static/media/progressbar3.05b120d48857e86cf910ddfaeb3c37ae.svg";
export { ForwardRef as ReactComponent };